import React from "react";
import styled from "styled-components";

import { CPanel, CTextInput, CTextArea, H3 } from "@appcues/component-library";

export default class SegmentMeta extends React.Component {
  render() {
    const { name, description } = this.props;
    return (
      <CPanel>
        <H3 marginBottom={24}>Segment details</H3>
        <CTextInput.Group label="Name">
          <CTextInput
            value={name}
            placeholder="Give your segment a name"
            onChange={name => this.props.setName(name)}
            maxWidth={320}
          />
        </CTextInput.Group>
        <CTextInput.Group
          label="Description"
          paddingBottom={0}
          marginBottom={0}
          maxWidth={640}
        >
          <StyledTextArea
            value={description}
            placeholder="Describe what this segment is for"
            onChange={description => this.props.setDescription(description)}
            rows={4}
          />
        </CTextInput.Group>
      </CPanel>
    );
  }
}

const StyledTextArea = styled(CTextArea)`
  max-width: 640px;
`;
